import React from 'react';
import ReactDOM from 'react-dom/client';
import PublicEpkApp from './PublicEpkApp';
import './public.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PublicEpkApp />
  </React.StrictMode>,
);
